import { useState, useEffect } from "react";
import Button from "../../../Custom/Button/Button";
import styles from "./styles";
import CustomSelect from "../globalno-dodavanje/CustomSelect";
import CustomSelectSimple from "./CustomSelectSimple";
import CustomCalendarInput from "./CustomCalendarInput";
import axios from "axios";
import { useGlobalContext } from "../../../../Context/Context";

const oceneAll = ["SPOSOBAN", "NIJE SPOSOBAN"];
const tipoviAll = ["PRETHODNI", "PERIODICNI"];

const nowDate = new Date()
  .toLocaleDateString("sr-RS", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  })
  .replaceAll("/", ".")
  .slice(0, -1);

const emptyObrazac = {
  radnoMesto: { id: -1, name: "" },
  zaposlen: { id: -1, name: "" },
  tipPregleda: "PERIODICNI",
  interval: "12",
  datum: nowDate,
  datumSledeci: nowDate,
  brojIzvestaja: "",
  ocena: "",
  mere: "",
};

function EvidencijeObrazac1Dodavanje({ setIsDodavanje, onRefresh }) {
  const [obrazac, setObrazac] = useState(emptyObrazac);
  const [radnaMesta, setRadnaMesta] = useState([]);
  const [zaposleni, setZaposleni] = useState([]);

  const { baseUrl, selectedMainEntity } = useGlobalContext();

  useEffect(() => {
    const fetchLookups = async () => {
      try {
        const { data } = await axios.post(
          `${baseUrl}/evidencija1/get_lookups.php`,
          { company_id: selectedMainEntity.company_id },
        );
        if (data.status === 200) {
          setRadnaMesta(data.radna_mesta);
          setZaposleni(data.zaposleni);
        }
      } catch (e) {
        console.error("Greška:", e);
      }
    };
    fetchLookups();
  }, []);

  const handleChange = (newValue, field) => {
    setObrazac((prev) => ({ ...prev, [field]: newValue }));
  };

  const handleChangeDate = (newValue) => {
    handleChange(newValue, "datum");
    const parts = newValue.split(".");
    const dateStr = [parts[1], parts[0], parts[2]].join("/");
    const sledeci = new Date(dateStr);
    sledeci.setMonth(sledeci.getMonth() + parseInt(obrazac.interval));
    const sledeciStr = sledeci
      .toLocaleDateString("sr-RS", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      })
      .replaceAll("/", ".")
      .slice(0, -1);
    setObrazac((prev) => ({ ...prev, datumSledeci: sledeciStr }));
  };

  const handleChangeInterval = (newValue) => {
    handleChange(newValue, "interval");
    if (obrazac.datum) {
      const parts = obrazac.datum.split(".");
      const dateStr = [parts[1], parts[0], parts[2]].join("/");
      const sledeci = new Date(dateStr);
      sledeci.setMonth(sledeci.getMonth() + parseInt(newValue));
      const sledeciStr = sledeci
        .toLocaleDateString("sr-RS", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        })
        .replaceAll("/", ".")
        .slice(0, -1);
      setObrazac((prev) => ({ ...prev, datumSledeci: sledeciStr }));
    }
  };

  const formatDateForApi = (dateStr) => {
    if (!dateStr) return null;
    const parts = dateStr.split(".");
    if (parts.length < 3) return null;
    return `${parts[2]}-${parts[1]}-${parts[0]}`;
  };

  const handleSacuvaj = async () => {
    console.log("Zaposlen:", obrazac.zaposlen);
    try {
      const { data } = await axios.post(`${baseUrl}/evidencija1/create.php`, {
        company_id: selectedMainEntity.company_id,
        workplace_id: obrazac.radnoMesto.id,
        employee_id: obrazac.zaposlen.employee_id,
        interval_meseci: obrazac.interval,
        tip_pregleda: obrazac.tipPregleda,
        datum_pregleda: formatDateForApi(obrazac.datum),
        datum_sledeci: formatDateForApi(obrazac.datumSledeci),
        broj_izvestaja: obrazac.brojIzvestaja,
        ocena: obrazac.ocena,
        mere: obrazac.mere,
      });
      if (data.status === 200) {
        onRefresh();
        setIsDodavanje(false);
      }
    } catch (e) {
      console.error("Greška:", e);
    }
  };

  const handleOdustani = () => {
    setIsDodavanje(false);
  };

  const isDisabledSacuvaj =
    obrazac.zaposlen.id === -1 ||
    obrazac.radnoMesto.id === -1 ||
    !obrazac.brojIzvestaja ||
    !obrazac.ocena ||
    !obrazac.mere;

  return (
    <div>
      <div
        style={{
          display: "flex",
          gap: "10px",
          width: "100%",
          justifyContent: "space-between",
        }}
      >
        <div style={{ width: "15vw" }}>
          <CustomSelect
            label="РАДНО МЕСТО"
            allValues={radnaMesta}
            selectedValue={obrazac.radnoMesto}
            onSelectChange={(newValue) => handleChange(newValue, "radnoMesto")}
          />
        </div>

        <div style={{ width: "15vw" }}>
          <CustomSelect
            label="ИМЕ И ПРЕЗИМЕ"
            allValues={zaposleni}
            selectedValue={obrazac.zaposlen}
            onSelectChange={(newValue) => handleChange(newValue, "zaposlen")}
          />
        </div>

        <div style={{ width: "8vw" }}>
          <CustomSelectSimple
            label="ТИП"
            allValues={tipoviAll}
            selectedValue={obrazac.tipPregleda}
            onSelectChange={(newValue) => handleChange(newValue, "tipPregleda")}
          />
        </div>

        <div style={{ width: "6vw" }}>
          <div
            style={{
              fontWeight: "bold",
              fontSize: "16px",
              marginBottom: "5px",
            }}
          >
            ИНТЕРВАЛ
          </div>
          <input
            value={obrazac.interval}
            onChange={(e) => handleChangeInterval(e.target.value)}
            style={{
              fontSize: "16px",
              height: "40px",
              padding: "10px",
              width: "100%",
            }}
          />
        </div>

        <div>
          <CustomCalendarInput
            label="IZVRŠEN"
            value={obrazac.datum}
            onChange={handleChangeDate}
          />
        </div>

        <div style={{ width: "10vw" }}>
          <div style={styles.natpis}>БРОЈ ИЗВЕШТАЈА</div>
          <input
            value={obrazac.brojIzvestaja}
            onChange={(e) => handleChange(e.target.value, "brojIzvestaja")}
            style={{
              fontSize: "16px",
              height: "40px",
              padding: "10px",
              width: "100%",
            }}
          />
        </div>

        <div style={{ width: "8vw" }}>
          <CustomSelectSimple
            label="ОЦЕНА"
            allValues={oceneAll}
            selectedValue={obrazac.ocena}
            onSelectChange={(newValue) => handleChange(newValue, "ocena")}
          />
        </div>

        <div style={{ width: "15vw" }}>
          <div
            style={{
              fontWeight: "bold",
              fontSize: "16px",
              marginBottom: "5px",
            }}
          >
            ПРЕДУЗЕТЕ МЕРЕ
          </div>
          <input
            value={obrazac.mere}
            onChange={(e) => handleChange(e.target.value, "mere")}
            style={{
              fontSize: "16px",
              height: "40px",
              padding: "10px",
              width: "100%",
            }}
          />
        </div>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          gap: "10px",
          marginTop: "20px",
        }}
      >
        <div onClick={handleOdustani}>
          <Button activation={true} style={styles.button}>
            ОДУСТАНИ
          </Button>
        </div>
        <div
          onClick={isDisabledSacuvaj ? undefined : handleSacuvaj}
          style={{ opacity: isDisabledSacuvaj ? 0.5 : 1 }}
        >
          <Button
            isDisabled={isDisabledSacuvaj}
            activation={true}
            style={styles.button}
          >
            САЧУВАЈ
          </Button>
        </div>
      </div>
    </div>
  );
}

export default EvidencijeObrazac1Dodavanje;
